/**
 * alfavita-quiz3.js
 * 14-step "Metas" hair-loss quiz for AlfaVita — replicates hims.com/c/hl/goals (Spanish).
 * Clean flow: single-select questions auto-advance on click; multi-select +
 * between-slides use a Continue button; commitment gate is a Sí/No choice.
 * Collects answers Q1-Q9 + Q12 + email → logs to Notion via Cloudflare Worker at /quiz3.
 * Per-step tracking: fbq('trackCustom', 'Quiz3Step' + N) — event name encodes step
 * because Meta strips custom params for sensitive-vertical (hair loss) pixels.
 */

(function () {
  'use strict';

  var answers = {
    q1: '', q2: '', q3: '', q4: '', q5: [],
    q6: '', q7: '', q8: '', q9: '', q10: '', q12: '', email: ''
  };

  var totalSteps = 16;
  var wrap;

  // ── Per-step funnel tracking ──────────────────────────────────────────────
  var sessionId = 'q' + Math.random().toString(36).slice(2, 10) + Date.now().toString(36);
  var lastStep  = 0;

  function trackStep(n) {
    if (n === lastStep) return; // dedupe accidental re-fires
    lastStep = n;
    try {
      if (window.fbq) {
        window.fbq('trackCustom', 'Quiz3Step' + n);
      }
      if (window.gtag) {
        window.gtag('event', 'quiz3_step_view', { step: n, session_id: sessionId });
      }
      if (window.clarity) {
        window.clarity('set', 'quiz3_step', String(n));
        window.clarity('event', 'Quiz3Step' + n);
      }
    } catch (e) { /* silent — never break the quiz on a tracking error */ }
  }

  function goToStep(n) {
    document.querySelectorAll('.avq3-step').forEach(function (s) {
      s.classList.remove('avq3-active');
    });
    var target = document.getElementById('avq3-' + n);
    if (target) {
      target.classList.add('avq3-active');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    if (n === 14) runPctCounters();

    trackStep(n);
  }

  // ── Step 13: animates SVG circle strokes + percentage text counters
  var CIRCUMFERENCE = 289.03; // 2 * π * r46
  function runPctCounters() {
    var counters = [
      { pctId: 'avq3-pct-metas',      circleId: 'avq3-circle-metas',      target: 92, delay: 200  },
      { pctId: 'avq3-pct-ajuste',     circleId: 'avq3-circle-ajuste',     target: 88, delay: 700  },
      { pctId: 'avq3-pct-esenciales', circleId: 'avq3-circle-esenciales', target: 95, delay: 1200 }
    ];
    counters.forEach(function (c) {
      setTimeout(function () {
        var pctEl    = document.getElementById(c.pctId);
        var circleEl = document.getElementById(c.circleId);
        if (!pctEl) return;
        var startTime = null;
        var duration  = 1200;
        function tick(ts) {
          if (!startTime) startTime = ts;
          var progress = Math.min((ts - startTime) / duration, 1);
          var eased    = 1 - Math.pow(1 - progress, 3);
          var pct      = eased * c.target;
          pctEl.textContent = Math.floor(pct) + '%';
          if (circleEl) circleEl.style.strokeDashoffset = (CIRCUMFERENCE * (1 - pct / 100)).toFixed(2);
          if (progress < 1) {
            requestAnimationFrame(tick);
          } else {
            pctEl.textContent = c.target + '%';
            if (circleEl) circleEl.style.strokeDashoffset = (CIRCUMFERENCE * (1 - c.target / 100)).toFixed(2);
          }
        }
        requestAnimationFrame(tick);
      }, c.delay);
    });
  }

  // ── Single-choice: highlight the card, store answer, auto-advance ─────────
  function handleOptionClick(e) {
    var el   = e.currentTarget;
    var q    = el.dataset.q;
    var step = parseInt(el.dataset.step, 10);
    var stepEl = document.getElementById('avq3-' + step);

    if (stepEl) {
      stepEl.querySelectorAll('.avq3-text-card, .avq3-card').forEach(function (c) {
        c.classList.remove('avq3-selected');
      });
    }
    el.classList.add('avq3-selected');

    if (q) answers['q' + q] = el.dataset.answer;

    // Auto-advance — no "Continuar" needed on single-select questions
    setTimeout(function () { goToStep(step + 1); }, 180);
  }

  // ── Continue / interstitial advance ───────────────────────────────────────
  function handleContinueClick(e) {
    var step = parseInt(e.currentTarget.dataset.step, 10);
    goToStep(step + 1);
  }

  // ── Multi-select (Q5) ─────────────────────────────────────────────────────
  function handleMultiContinue() {
    var selected = [];
    document.querySelectorAll('.avq3-checkbox:checked').forEach(function (cb) {
      selected.push(cb.value);
    });
    answers.q5 = selected;
    goToStep(6);
  }

  // ── Step 14: loader "Ver mi plan" → commitment gate (step 15) ────────────
  function handleLoaderCta() {
    goToStep(15);
  }

  // ── Step 15: commitment gate (Sí/No) ─────────────────────────────────────
  // Sí → email capture (step 16). No → redirect to the "sorry" page.
  function handleCommitClick(e) {
    var el = e.currentTarget;
    var answer = el.dataset.answer;
    if (el.dataset.q) answers['q' + el.dataset.q] = answer;
    if (answer === 'No') {
      window.location.href = (wrap.dataset.sorry || '/pages/sorry').trim();
      return;
    }
    goToStep(16);
  }

  // ── Step 14: email validation + final submit ──────────────────────────────
  function handleEmailSubmit(e) {
    e.preventDefault();
    var emailInput = document.getElementById('avq3-email-input');
    var emailError = document.getElementById('avq3-email-error');
    var submitBtn  = document.getElementById('avq3-email-submit');
    var email      = emailInput ? emailInput.value.trim() : '';

    // Email is required
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      if (emailError) emailError.style.display = 'block';
      return;
    }
    if (emailError) emailError.style.display = 'none';
    if (submitBtn)  submitBtn.disabled = true;

    answers.email = email;

    var workerUrl   = (wrap.dataset.worker   || '').trim();
    var redirectUrl = (wrap.dataset.redirect || '/pages/alfavita2').trim();

    function doRedirect() { window.location.href = redirectUrl; }

    if (workerUrl) {
      fetch(workerUrl + '/quiz3', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          source: window.location.href,
          email: answers.email,
          q1: answers.q1, q2: answers.q2, q3: answers.q3,
          q4: answers.q4, q5: answers.q5.join(', '),
          q6: answers.q6, q7: answers.q7, q8: answers.q8,
          q9: answers.q9, q10: answers.q10, q12: answers.q12
        })
      }).then(doRedirect).catch(doRedirect);
      setTimeout(doRedirect, 3000);
    } else {
      doRedirect();
    }
  }

  function init() {
    wrap = document.querySelector('.avq3-wrap');
    if (!wrap) return;

    // Skip link
    var skipBtn = document.getElementById('avq3-skip');
    if (skipBtn) {
      skipBtn.addEventListener('click', function () {
        window.location.href = (wrap.dataset.redirect || '/pages/alfavita2').trim();
      });
    }

    // Single-choice cards → select (not advance)
    document.querySelectorAll('.avq3-card[data-q], .avq3-text-card[data-q]').forEach(function (el) {
      el.addEventListener('click', handleOptionClick);
    });

    // Continue / interstitial buttons → advance
    document.querySelectorAll('.avq3-continue-btn').forEach(function (btn) {
      btn.addEventListener('click', handleContinueClick);
    });

    // Multi-select continue (Q5)
    var multiContinue = document.getElementById('avq3-multi-continue');
    if (multiContinue) multiContinue.addEventListener('click', handleMultiContinue);

    // "Todas las anteriores" toggle
    var allCheck = document.querySelector('.avq3-check-all');
    if (allCheck) {
      allCheck.addEventListener('change', function () {
        document.querySelectorAll('.avq3-checkbox:not(.avq3-check-all)').forEach(function (cb) {
          cb.checked = allCheck.checked;
        });
      });
    }

    // Step 14: loader "Ver mi plan" → go to commitment gate
    var finalBtn = document.getElementById('avq3-final-btn');
    if (finalBtn) finalBtn.addEventListener('click', handleLoaderCta);

    // Step 15: commitment Sí/No → go to email step
    document.querySelectorAll('.avq3-commit-btn').forEach(function (btn) {
      btn.addEventListener('click', handleCommitClick);
    });

    // Step 16: email form submit
    var emailForm = document.getElementById('avq3-email-form');
    if (emailForm) emailForm.addEventListener('submit', handleEmailSubmit);

    // Fire the step-1 view (page lands on step 1 without an explicit goToStep call)
    trackStep(1);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
